<script lang="ts">
	import { supabase } from "./supaBase";
	import { currentUser } from "./store";

	supabase.auth.onAuthStateChange((_, session) => {
		if (session) {
			currentUser.set(session.user);
		} else {
			currentUser.set(null);
		}
	});

	const signInWithGithub = async () => {
		var getUrl = window.location;
		var baseUrl = getUrl.protocol + "//" + getUrl.host;
		const { user, session, error } = await supabase.auth.signIn(
			{
				provider: "github",
			},
			{
				redirectTo: baseUrl,
			}
		);
	};

	const signOut = async () => {
		try {
			let { error } = await supabase.auth.signOut();
			if (error) throw error;
		} catch (error) {
			alert(error.message);
		} finally {
		}
	};
</script>

{#if !$currentUser}
	<button on:click={() => signInWithGithub()}>Login</button>
{:else}
	<button on:click={() => signOut()}>{$currentUser.email} - Signout</button>
{/if}
